import { render, staticRenderFns } from "./RoleChat.vue?vue&type=template&id=0b372558&scoped=true"
import script from "./RoleChat.vue?vue&type=script&lang=js"
export * from "./RoleChat.vue?vue&type=script&lang=js"
import style0 from "./RoleChat.vue?vue&type=style&index=0&id=0b372558&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b372558",
  null
  
)

export default component.exports